import { TableRes } from '../../../shared/types';
import { pspActiveOnChange } from './pspActiveOnChange';
import BaseSetColumnConfig from '../../../shared/components/grid/SetColumnConfig';

type Props = {
  tableRes: TableRes;
  customProps?: any;
  allColumns: any[];
};

type OnChangeArgs = {
  rowId: number | string;
  row: Record<string, any>;
  value: any;
};

export function SetColumnConfig(props: Props) {
  const { tableRes } = props;
  const { gridColumns: columnsConfig } = BaseSetColumnConfig(props);
  const allColumns = (props.allColumns ?? []).map((col) => col.attrInternalName);

  const gridColumns = columnsConfig.reduce(
    (acc, col) => {
      if (col.attrInternalName === 'active') {
        col.onValueChange = async (params: OnChangeArgs) => {
          await pspActiveOnChange({
            ...params,
            updateRow: props.customProps?.updateRow,
            tableDetails: tableRes,
            screenGridId: props.customProps?.screenGridId,
            setRows: props.customProps?.setRows,
            setAllRowsData: props.customProps?.setAllRowsData,
            allColumns,
            updateCustomConfig: props.customProps?.updateCustomConfig,
            customConfig: props.customProps?.customConfig,
            getAllRows: props.customProps?.getAllRows,
          });
        };
      }
      acc.push(col);
      return acc;
    },
    [] as typeof columnsConfig,
  );

  return { gridColumns };
}
